import React from "react";
import { IconNames } from "core/models";
import { Button } from "ui/components";
import { cx } from "utils/join-classnames";
import styles from "./VolumeControls.module.scss";

interface Props {
    volumeValue: number;
    muted: boolean;
    size?: "small" | "medium" | "large";
    onChange(newValue: number): void;
    onMuteChange(status: boolean): void;
    onSliderToggle?(state: boolean): void;
}

const volumeIconName = (volumeValue: number, muted: boolean): IconNames => {
    if (muted) {
        return "volume-off";
    }
    if (volumeValue === 0) {
        return "volume-off";
    }
    if (volumeValue < 0.3) {
        return "volume-low";
    }
    if (volumeValue < 0.6) {
        return "volume-mid";
    }
    if (volumeValue >= 0.6) {
        return "volume";
    }
    return "volume";
};

const VolumeControls: React.FC<Props> = ({
    volumeValue = 1,
    onChange,
    onMuteChange,
    muted,
    size = "medium",
    onSliderToggle,
}) => {
    const [sliderVisible, setSliderVisible] = React.useState<boolean>(false);
    const toggleSlider = () => {
        if (onSliderToggle) {
            onSliderToggle(!sliderVisible);
        }
        setSliderVisible(!sliderVisible);
    };
    const toggleMute = () => {
        onMuteChange(!muted);
    };
    const onSlide = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(+e.target.value / 100);
    };

    const sliderStyle = {
        background: `linear-gradient(90deg, #FFF  0%, #FFF ${
            volumeValue * 100
        }%, rgba(255,255,255, 0.5) ${volumeValue * 100}%)`,
    };
    return (
        <div
            className={styles.volumecontrols}
            onMouseEnter={toggleSlider}
            onMouseLeave={toggleSlider}
        >
            <Button
                type="function"
                icon={volumeIconName(volumeValue, muted)}
                size={size !== "small" ? "large" : "medium"}
                onClick={toggleMute}
            />
            <input
                type="range"
                min="0"
                max="100"
                value={volumeValue * 100}
                onInput={onSlide}
                className={cx(
                    styles.slider,
                    sliderVisible && styles.slider__visible,
                    size === "small" && styles.small,
                )}
                style={sliderStyle}
            />
        </div>
    );
};

export default VolumeControls;
